export enum Operator {
  /**
   * subcriteria (criterion.criteria) are true.
   */
  and = 'and',
  /**
   * Shortcut for greaterThan + lessThan + and.
   */
  between = 'between',
  /**
   * Shortcut for greaterOrEqual + lessOrEqual + and.
   */
  betweenInclusive = 'betweenInclusive',
  /**
   * Contains as sub-string (match case).
   */
  contains = 'contains',
  /**
   * Ends with (match case).
   */
  endsWith = 'endsWith',
  /**
   * Exactly equal to.
   */
  equals = 'equals',
  /**
   * Greater than or equal to.
   */
  greaterOrEqual = 'greaterOrEqual',
  /**
   * Greater than.
   */
  greaterThan = 'greaterThan',
  /**
   * Contains as sub-string (case insensitive).
   */
  iContains = 'iContains',
  /**
   * Contains as sub-string another field value (specify fieldName as criterion.value; case insensitive).
   */
  iEndsWith = 'iEndsWith',
  /**
   * exactly equal to, if case is disregarded (case insensitive).
   */
  iEquals = 'iEquals',
  /**
   * Does not contain as sub-string (case insensitive).
   */
  iNotContains = 'iNotContains',
  /**
   * Not equal to, if case is disregarded (case insensitive).
   */
  iNotEqual = 'iNotEqual',
  /**
   * Value is null.
   */
  isNull = 'isNull',
  /**
   * Starts with (case insensitive).
   */
  iStartsWith = 'iStartsWith',
  /**
   * Less than or equal to.
   */
  lessOrEqual = 'lessOrEqual',
  /**
   * Less than.
   */
  lessThan = 'lessThan',
  /**
   * All subcriteria (criterion.criteria) are false.
   */
  not = 'not',
  /**
   * Does not contain as sub-string (match case).
   */
  notContains = 'notContains',
  /**
   * Not equal to.
   */
  notEqual = 'notEqual',
  /**
   * Value is non-null.
   */
  notNull = 'notNull',
  /**
   * At least one subcriteria (criterion.criteria) is true.
   */
  or = 'or',
  /**
   * Starts with (match case).
   */
  startsWith = 'startsWith',
  /**
   * Contains with custom logic.
   */
  iContainsCustom = 'iContainsCustom',
  /**
   * Equal to any of criterion.values (multiple choice). Client-side only - used by column filters,
   * which never reach the backend (see excludeColumnFilterCriteria).
   */
  inList = 'inList'
}
